import React from "react";

import YandexMap from "components/YandexMap/YandexMap";
import Search from "components/Search/Search";
import ControlsContainer from "components/ControlsContainer/ControlsContainer";
import "./index.css";

const Controls = () => {
  return (
    <section>
      <Search />
      <ControlsContainer />
      <YandexMap />
    </section>
  );
};

export default Controls;



// WEBPACK FOOTER //
// ./src/components/Controls/index.js